"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FileInputButton = FileInputButton;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _button = require("../button");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const acceptedTypes = {
  '*': '*',
  image: 'image/*',
  csv: '.csv',
  gpx: '.gpx',
  geojson: '.geojson',
  shp: '.zip',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
};
function FileInputButton({
  Button: _Button,
  buttonLabel,
  type,
  file,
  onChange,
  ...props
}) {
  const inputRef = (0, _react.useRef)(null);
  function handleChange({
    target: {
      files
    }
  }) {
    const newFile = files?.[0];
    onChange(newFile || file);
  }
  const Button = _Button || _button.Button;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("input", {
    accept: acceptedTypes[type],
    onChange: handleChange,
    onClick: ({
      currentTarget
    }) => currentTarget.value = '',
    ref: inputRef,
    style: {
      display: 'none'
    },
    type: "file"
  }), /*#__PURE__*/_react.default.createElement(Button, _extends({
    onClick: () => inputRef.current?.click()
  }, props), buttonLabel || /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "commons.actions.choose",
    values: {
      context: type === '*' ? 'file' : type
    }
  })));
}